//import Data from 'data';

import Data from "data";
import { defaultSummon } from "logic/monster/summons";
import { AnimationCalculator } from "../animation";
import { d2_addpercent, d2_percent, skillAuraStats, skillFormula, skillPassiveStats } from "../calc";
import { DamageCalculator } from "../damage";
import { DPSCalculator } from "../dps";

const functions = {};

// Dragon Tail

functions[50] = {
  info(id, stats, level, target) {
    const skill = Data.skills[id];

    const calc = new DamageCalculator(stats, stats.weapon1, false, skill.param8 && stats.base.progressive ? false : true);
    if (skill.finishing) {
      calc.finisher();
    }
    if (skill.etype) {
      calc.elemental(skill.etype, skillFormula(skill, 'enms', stats, level),
        skillFormula(skill, 'exms', stats, level), skillFormula(skill, 'edln', stats, level));
    }
    calc.kickdamage();
    calc.physical(skillFormula(skill, 'pdns', stats, level), skillFormula(skill, 'pdxs', stats, level));
    calc.skillbonus('tohit_percent', skillFormula(skill, 'toht', stats, level));
    calc.calculate(target);

    const expl = new DamageCalculator(stats, stats.weapon1, false, false);
    const percent = skillFormula(skill, 'clc1', stats, level);
    const fire_mastery = stats.base.passive_fire_mastery || 0;
    expl.skillbonus('firemindam', d2_addpercent(d2_percent(calc.applied_physmindam, percent), fire_mastery));
    expl.skillbonus('firemaxdam', d2_addpercent(d2_percent(calc.applied_physmaxdam, percent), fire_mastery));

    return {
      damage: {
        damage: calc,
        explosion: expl.calculate(target),
      },
      animation: new AnimationCalculator(stats, skill).calculate(),
    };
  },
  dps(id, stats, level, target, info) {
    if (!info?.damage || !info.animation) return;
    const calc = new DPSCalculator();
    calc.basic_damage('damage', info.damage.damage, info.animation);
    calc.basic_damage('explosion', info.damage.explosion, info.animation);
    return calc.calculate(stats, target);
  },
};

// Mind Blast

functions[51] = {
  damage(skill, stats, weapon, level, target) {
    const calc = new DamageCalculator(stats, weapon, false, false);
    calc.elemental(skill.etype, skillFormula(skill, 'enms', stats, level),
      skillFormula(skill, 'exms', stats, level), skillFormula(skill, 'edln', stats, level));
    calc.physical(skillFormula(skill, 'pdns', stats, level), skillFormula(skill, 'pdxs', stats, level));
    return calc.calculate(target);
  },
};

// Dragon Flight

functions[52] = {
  damage(skill, stats, weapon, level, target) {
    const calc = new DamageCalculator(stats, weapon, false, skill.param8 && stats.base.progressive ? false : true);
    if (skill.finishing) {
      calc.finisher();
    }
    if (skill.etype) {
      calc.elemental(skill.etype, skillFormula(skill, 'enms', stats, level),
        skillFormula(skill, 'exms', stats, level), skillFormula(skill, 'edln', stats, level));
    }
    calc.skillbonus('damagepercent', skillFormula(skill, 'ln12', stats, level));
    calc.kickdamage();
    calc.physical(skillFormula(skill, 'pdns', stats, level), skillFormula(skill, 'pdxs', stats, level));
    calc.skillbonus('tohit_percent', skillFormula(skill, 'toht', stats, level));
    return calc.calculate(target);
  },
  animation(skill, stats) {
    const anim = new AnimationCalculator(stats, skill);
    anim.hits = 1;
    return anim.calculate();
  },
};

// Blade Shield

functions[54] = {
  damage(skill, stats, weapon, level, target) {
    if (!weapon) return null;
    const calc = new DamageCalculator(stats, weapon, false, true);
    if (skill.etype) {
      calc.elemental(skill.etype, skillFormula(skill, 'enms', stats, level),
        skillFormula(skill, 'exms', stats, level), skillFormula(skill, 'edln', stats, level));
    }
    calc.skillbonus('base_mindamage', skillFormula(skill, 'pdns', stats, level));
    calc.skillbonus('base_maxdamage', skillFormula(skill, 'pdxs', stats, level));
    calc.srcdam(skill.srcdam, null, null, true);
    calc.skillbonus('tohit_percent', skillFormula(skill, 'toht', stats, level));
    calc.resultflags = skill.resultflags;
    return calc.calculate(target);
  },
  dps: () => null,
};

// Corpse Explosion

functions[55] = {
  damage(skill, stats, weapon, level, target) {
    const single = (target.unit === 'monster' ? target.single : stats.single);
    const monLvl = Data.monLvl[target.level];
    const health = monLvl[(Data.info.pd2 || single ? 'l' : '') + 'hp' + ['', 'n', 'h'][target.difficulty]];

    const damage = new DamageCalculator(stats, weapon, false, false);
    damage.skillbonus('mindamage', d2_percent(health << 8, skillFormula(skill, 'clc1', stats, level)));
    damage.skillbonus('maxdamage', d2_percent(health << 8, skillFormula(skill, 'clc2', stats, level)));
    damage.convert(skill.etype, skillFormula(skill, 'clc3', stats, level));
    return damage.calculate(target, false, true);
  },
  dps: () => null,
};

// Clay/Blood/Fire Golem

functions[56] = {
  summon(id, stats, level, target) {
    const resist = stats.base.passive_summon_resist || 0;
    return defaultSummon(id, stats, level, target, {
      stats: {
        skill89: {
          fireresist: resist,
          coldresist: resist,
          lightresist: resist,
          poisonresist: resist,
        },
      },
    });
  },
};

// Clay/Blood/Fire Golem

functions[57] = {
  summon(id, stats, level, target) {
    const resist = stats.base.passive_summon_resist || 0;
    return defaultSummon(id, stats, level, target, {
      stats: {
        skill89: {
          fireresist: resist,
          coldresist: resist,
          lightresist: resist,
          poisonresist: resist,
        },
      },
    });
  },
};

// Revive

functions[58] = {
  checkTarget(target) {
    return target?.type === 'normal';
  },
  summon(id, stats, level, target) {
    if (target?.type !== 'normal') return;
    const skill = Data.skills[id];
    return {
      revive: true,
      level: stats.level,
  
      skill: id,
      skillLevel: level,
  
      life_percent: skillFormula(skill, 'clc1', stats, level),
      stats: {
        skill: {
          ...skillAuraStats(skill, stats, level),
          ...skillPassiveStats(skill, stats, level),
        },
      },
    };
  },
};

export default functions;
